import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-tiny-popover';
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle } from 'react-icons/fa';
import color from 'color';

import ProfilePic from '../ProfilePic';
import Editor from '../Editor';
import Input from '~/components/Input';
import {
  Container,
  ActionBox,
  ColorBox,
  Label,
  ColorPicker,
  ButtonNext,
  ButtonCancel,
} from './styles';

function Template2({ mode, value, onChange, disabled }) {
  const [actionIsOpen, setActionIsOpen] = useState(false);
  const [dataBkp, setDataBkp] = useState({
    actionLabel: '',
    actionLink: '',
    actionColor: '',
  });
  const renderProfileBox = () => (
    <div className="template-profilepic-box">
      <ProfilePic profilePic={value.profilePic} />
    </div>
  );

  const renderContentBox = () => (
    <div className="template-content-box">
      <Editor
        disabled={disabled}
        multiple
        buttonsShow={{
          hasFont: true,
          hasAlign: true,
          hasBold: true,
          hasItalic: true,
          hasUnderlined: true,
        }}
        textValue={value.content}
        onChangeTextValue={(content) =>
          onChange({
            ...value,
            content,
          })
        }
        textStyle={value.styleContent}
        onChangeTextStyle={(styleContent) =>
          onChange({
            ...value,
            styleContent,
          })
        }
      />
    </div>
  );

  const renderButtonBox = () => (
    <div className="template-button-box">
      <Popover
        isOpen={actionIsOpen}
        position="top"
        padding={5}
        onClickOutside={() => {}}
        containerStyle={{
          overflow: 'visible',
        }}
        content={() => (
          <ActionBox>
            <div className="action-box-row" style={{ marginBottom: 30 }}>
              <Label>Editar botão de direcionamento</Label>
            </div>
            <div className="action-box-row" style={{ marginBottom: 20 }}>
              <Label style={{ marginBottom: 5 }}>
                Texto botão
                <FaInfoCircle
                  data-tip="Texto botão."
                  data-for="tooltip-provider"
                />
              </Label>
              <Input
                name="inputNomeRede"
                type="text"
                placeholder="Texto botão"
                value={value.actionLabel}
                onChange={(e) => {
                  onChange({
                    ...value,
                    actionLabel: e.target.value,
                  });
                }}
              />
            </div>
            <div className="action-box-row" style={{ marginBottom: 20 }}>
              <Label style={{ marginBottom: 5 }}>
                Inserir link
                <FaInfoCircle
                  data-tip="Escolha um nome que seja de fácil identificação da campanha."
                  data-for="tooltip-provider"
                />
              </Label>
              <Input
                name="inputNomeRede"
                type="text"
                placeholder="https://"
                value={value.actionLink}
                onChange={(e) => {
                  onChange({
                    ...value,
                    actionLink: e.target.value,
                  });
                }}
              />
            </div>
            <div className="action-box-row" style={{ marginBottom: 20 }}>
              <ColorBox>
                <Label>Selecione suas cores</Label>
                <ColorPicker
                  value={value.actionColor}
                  onChange={(hex) => {
                    onChange({
                      ...value,
                      actionColor: hex,
                    });
                  }}
                  className="tour-step-3"
                />
              </ColorBox>
            </div>
            <div className="action-box-row" style={{ flexDirection: 'row' }}>
              <ButtonNext
                disabled={
                  !value.actionColor || !value.actionLink || !value.actionLabel
                }
                title="Salvar"
                onClick={() => {
                  setActionIsOpen(false);
                }}
              />
              <ButtonCancel
                title="Cancelar"
                onClick={() => {
                  setActionIsOpen(false);
                  onChange({
                    ...value,
                    ...dataBkp,
                  });
                }}
              />
            </div>
            <ReactTooltip
              place="right"
              backgroundColor="#FFFFFF"
              textColor="#323232"
              border
              borderColor="#d1d1d1"
              className="tooltip-wrap"
              id="tooltip-provider"
            />
          </ActionBox>
        )}
      >
        <button
          type="button"
          style={{
            backgroundColor: value.actionColor,
            color: color(value.actionColor).isLight() ? '#0A0724' : '#ffffff',
          }}
          onClick={() => {
            setActionIsOpen(!disabled);
            setDataBkp({
              actionLabel: value.actionLabel,
              actionLink: value.actionLink,
              actionColor: value.actionColor,
            });
          }}
        >
          {value.actionLabel || 'Texto de ação'}
        </button>
      </Popover>
    </div>
  );

  const renderFooterBox = () => (
    <div className="template-footer-box">
      <b>Enviado por Apolo PME</b>
      <span>
        Caso não queira mais receber e-mails como este,
        <a href="https://google.com" target="_blank" rel="noreferrer">
          clique aqui
        </a>
      </span>
    </div>
  );

  return (
    <Container mode={mode}>
      {renderProfileBox()}
      {renderContentBox()}
      {renderButtonBox()}
      {renderFooterBox()}
    </Container>
  );
}

Template2.defaultProps = {
  disabled: false,
};

Template2.propTypes = {
  mode: PropTypes.string.isRequired,
  value: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default Template2;
